<div class="item-status" [ngClass]="{'item-status--disabled': status !== true && status !== false, 'item-status--checked': status === true, 'item-status--alert': status === false}">
  <div class="item-status__content">
    @if (status === true || status === false) {
      <div class="item-status__status" [ngClass]="{'item-status__status--checked': status === true, 'item-status__status--alert': status === false}">
        @if (status === true) {
          <vwui-icon iconName="vwui-check"></vwui-icon>
        }
        @if (status === false) {
          <vwui-icon iconName="alert"></vwui-icon>
        }
      </div>
    }
    <ng-content></ng-content>
  </div>
</div>
